import { ContainerModule } from 'inversify';
import { DataroomTenant } from '@dataroom/tenant/DataroomTenant';
import { DIUploadTypes } from '@/dataroom/app/DI/FileUpload/types';
import FileUploadDispatcherFactory from '@/dataroom/app/DI/FileUpload/FileUploadDispatcher/index';
import type {
  IFileUploadDispatcherFactory,
  IFileUploadDispatcherFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/FileUploadDispatcher/interfaces';

export const FileUploadModule = new ContainerModule(({ bind }) => {
  bind<IFileUploadDispatcherFactory>(DIUploadTypes.FileUploadDispatcherFactory)
    .to(FileUploadDispatcherFactory)
    .inSingletonScope();

  bind<IFileUploadDispatcherFactoryMethod>(DIUploadTypes.FileUploadDispatcher)
    .toFactory(({ get }) =>
      (tenantCode?: DataroomTenant) =>
        get<IFileUploadDispatcherFactory>(DIUploadTypes.FileUploadDispatcherFactory)
        .create(tenantCode),
    );
});
